import { query } from "@solidjs/router";
import { getRequestEvent } from "solid-js/web";
import { ADMIN, GROUPS } from "./constants";

import { getUserFromEvent } from "./auth";

//export const emailTemplates = () => import.meta.glob("../../emailTemplates/*.tsx", {	eager: true });

export * from "./cognito";
export * from "./dynamoDB";
export * from "./functions";
export * from "./pdf";
export * from "./accounts";
export * from "./server.email";
export * from "./dynamoQueries";

export const getUserInfo = async () => {
	"use server";

	return await getUserFromEvent( getRequestEvent() );
};

export const getMenu = query(async () => {
	"use server";

	const user = await getUserFromEvent(getRequestEvent());

	const links = [
		{ caption: "Home", href: "/dashboard" },
		{ caption: "Projects", href: "/dashboard/projects" },
		{ caption: "Account", href: "/dashboard/account" },
		{ caption: "Log Book", href: "/dashboard/logbook" },
		{ caption: "Assessment", href: "/dashboard/exams", inMenu: false },
	];

	if (user?.groups?.includes(ADMIN)) {
		links.push({ caption: "Admin", href: "/dashboard/admin/" });
	}

	return { links };
}, "getMenu");

